import { string } from "prop-types";

export default {
  name: string,
  floor: string,
  category: string,
};
